"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertUrisToReferences = exports.convertReferencesToUris = void 0;
var tslib_1 = require("tslib");
var api_client_bear_1 = require("@gooddata/api-client-bear");
var isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
var isObject_1 = tslib_1.__importDefault(require("lodash/isObject"));
var isString_1 = tslib_1.__importDefault(require("lodash/isString"));
var uuid_1 = require("uuid");
/*
 * Helpers
 */
var getReferenceValue = function (id, references) { return references[id]; };
var getReferenceId = function (value, references) {
    return Object.keys(references).find(function (id) { return references[id] === value; });
};
var defaultIdGenerator = function () { return uuid_1.v4().replace(/-/g, ""); };
/**
 * Recursively traverses the object and tries to apply a conversion to every string value
 */
var traverse = function (obj, convert) {
    if (isArray_1.default(obj)) {
        return obj.map(function (a) { return traverse(a, convert); });
    }
    else if (isObject_1.default(obj)) {
        return Object.keys(obj).reduce(function (result, key) {
            result[key] = traverse(obj[key], convert);
            return result;
        }, {});
    }
    else if (isString_1.default(obj)) {
        return convert(obj);
    }
    else {
        return obj;
    }
};
var createConverter = function (conversionFunction) {
    return function (conversionData, idGenerator) {
        if (idGenerator === void 0) { idGenerator = defaultIdGenerator; }
        return conversionFunction(conversionData, idGenerator);
    };
};
/*
 * Conversion from References to URIs
 */
var convertReferenceToUri = function (references) {
    return function (value) {
        return getReferenceValue(value, references) || value;
    };
};
/**
 * Converts URIs to reference based values
 *
 * @param conversionData - Data to convert
 * @param idGenerator - Function that returns unique ids, defaults to uuid
 *
 * @internal
 */
exports.convertReferencesToUris = createConverter(function (_a) {
    var references = _a.references, properties = _a.properties;
    return {
        properties: traverse(properties, convertReferenceToUri(references)),
        references: references,
    };
});
/*
 * Conversion from URIs to References
 */
var createUriToReferenceConverter = function (originalReferences, idGenerator) {
    var convertedReferences = {};
    return {
        convertedReferences: convertedReferences,
        conversion: function (value) {
            if (!api_client_bear_1.isUri(value)) {
                return value;
            }
            var id = getReferenceId(value, originalReferences) || // try to reuse original references
                getReferenceId(value, convertedReferences) || // or use already converted new references
                idGenerator(); // or get a completely new id
            convertedReferences[id] = value;
            return id;
        },
    };
};
/**
 * Converts URIs to reference based values
 *
 * @param conversionData - Data to convert
 * @param idGenerator - Function that returns unique ids, defaults to uuid
 * @internal
 */
exports.convertUrisToReferences = createConverter(function (_a, idGenerator) {
    var properties = _a.properties, references = _a.references;
    var converter = createUriToReferenceConverter(references, idGenerator);
    return {
        properties: traverse(properties, converter.conversion),
        references: converter.convertedReferences,
    };
});
//# sourceMappingURL=ReferenceConverter.js.map